import { createContext, useContext, useState, useCallback } from "react";
import { makeT, translateCheck, translateStatus, translateError } from "@/i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rexx_lang") || "it");

  const setLang = useCallback((l) => {
    localStorage.setItem("rexx_lang", l);
    setLangState(l);
  }, []);

  const t = makeT(lang);
  const tCheck = (name) => translateCheck(lang, name);
  const tStatus = (s) => translateStatus(lang, s);
  const tError = (m) => translateError(lang, m);

  return (
    <LangContext.Provider value={{ lang, setLang, t, tCheck, tStatus, tError }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
